export default __webpack_public_path__ + "fe3170f742068c0199cde4ac43d1f068.svg";